module.exports = __webpack_public_path__ + "pdf.png";